export default __webpack_public_path__ + "static/media/dribbble.ad0de53b.svg";